// src/api/rawItemsService.js ver 02 Dec 03 2025 3:25 pm - SB115
import { callCloudFunction } from './apiClient';

export const getRawItems = async (tenantid, token, page = 1, limit = 20, statusFilter = 'no-filter', rawItemCategorySeqIdFilter = 'no-filter') => { // NEW: ver 01
  return callCloudFunction('rawItemsCrud', 'GET', null, null, token, null,{
      pathParams: { tenantid, operation: 'list' },
      queryParams: { page, limit, statusfilter: statusFilter, rawitemcategoryseqidfilter: rawItemCategorySeqIdFilter } // NEW: ver 01
  });
};

export const getRawItemById = async (tenantid, id, token) => {
  return callCloudFunction('rawItemsCrud', 'GET', null, id, token, null,{
      pathParams: { tenantid, operation: 'getById', id }
  });
};

export const addRawItem = async (tenantid, rawItemData, token) => {
  return callCloudFunction('rawItemsCrud', 'POST', rawItemData, null, token, null,{
      pathParams: { tenantid, operation: 'add' }
  });
};

export const updateRawItem = async (tenantid, id, rawItemData, token) => {
  return callCloudFunction('rawItemsCrud', 'PUT', rawItemData, null, token, null,{
      pathParams: { tenantid, operation: 'update', id }
  });
};

// NEW: Helper to fetch all raw item categories for dropdowns
export const getAllRawItemCategoriesForDropdown = async (tenantid, token) => {
    // This calls the rawItemCategoryCrud 'list' operation but without pagination
    // to get all categories for the dropdown. Max limit might be needed for large lists.
    return callCloudFunction('rawItemCategoryCrud', 'GET', null, null, token, null,{
        pathParams: { tenantid, operation: 'list' },
        queryParams: { limit: 1000 } // Fetch a large enough limit for all categories
    });
};